const PRODUCTION_STOREFRONT_MEDIA_PRESENTATION_SENTINEL = "reviewed-enabled-v1";

function storefrontMediaPresentationEnabled({ deploymentEnvironment, sentinel } = {}) {
  const environment = String(deploymentEnvironment || "").trim().toLowerCase();
  if (environment === "production") {
    return String(sentinel || "").trim() === PRODUCTION_STOREFRONT_MEDIA_PRESENTATION_SENTINEL;
  }
  return environment === "staging" || environment === "development" || environment === "test";
}

function storefrontMediaPresentationBuildEnabled(env = process.env) {
  return storefrontMediaPresentationEnabled({
    deploymentEnvironment: env?.REACT_APP_DEPLOY_ENV || env?.NODE_ENV,
    sentinel: env?.REACT_APP_PRODUCTION_STOREFRONT_MEDIA_PRESENTATION,
  });
}

module.exports = {
  PRODUCTION_STOREFRONT_MEDIA_PRESENTATION_SENTINEL,
  storefrontMediaPresentationBuildEnabled,
  storefrontMediaPresentationEnabled,
};
